





















import Vue from 'vue';
import { mapGetters } from 'vuex';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  computed: {
    ...mapGetters('user', ['teacherStudioUrl']),
  },
  methods: {
    async deleteAllTranslations() {
      try {
        const dispatchPromise = await this.$store.dispatch(
          'studio/deleteAllTranslations'
        );
        this.$emit('close');
        this.$emit('onSubmit', dispatchPromise);
        await this.$store.dispatch(
          'studio/loadTranslations',
          this.teacherStudioUrl
        );
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('LABEL_EDITOR.TEXT.TRANSLATIONS_RESET_SUCCESS'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('LABEL_EDITOR.TEXT.TRANSLATIONS_RESET_ERROR'),
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
  },
});
